import { Modal, Button, ButtonToolbar, Placeholder } from 'rsuite';
function FilterUnMatchModal({ show, handleClose ,handleModalOk}) {
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleModalOk()
        }
      };
    return (
        
        <Modal size='xs' open={show} onClose={handleClose}  onKeyPress={handleKeyPress} centered>
        <Modal.Header>
          <Modal.Title> Unmatched Filters</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <p>
        Filters changed,
        Search again
                    </p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleModalOk} style={{backgroundColor:'#1ba1a7 ', color:"white"}} >
            Search
          </Button>
          <Button onClick={handleClose} appearance="subtle">
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
        
    );
}
export default FilterUnMatchModal